import React, { useState } from 'react'; 
import Login from './login/Login';
import Register from './login/Register';
import ShippingOneAmazon from './ShippingOneAmazon';
 const AccountAmazon = () => {
    const [isLogin, setIsLogin] = useState(true);

    const toggleView = () => setIsLogin(!isLogin);

    return (
        <section className="account py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    {isLogin ? (
                        <Login toggleView={toggleView} />
                    ) : (
                        <Register toggleView={toggleView} />
                    )}
                         {/* ShippingOneAmazon  */}
                        <ShippingOneAmazon/>
                      
                </div>
            </div>
        </section>
    );
};

export default AccountAmazon;
